export const cutomTraitsLinkPlugin = (editor) => {
  editor.Components.addType("link", {
    model: {
      defaults: {
        traits: [
          {
            type: "text",
            name: "Title",
            label: "Title",
            placeholder: "Enter title",
          },
          {
            type: "href",
            name: "href",
            label: "URL",
            changeProp: true,
          },
          {
            type: "select",
            name: "target",
            label: "Target",
            default: "_self",
            changeProp: true,
            options: [
              // Here the key is the `id` of the option
              { id: "_self", label: "This window", value: "_self" },
              { id: "_blank", label: "New window", value: "_blank" },
            ],
          },
        ],
      },
      init() {
        // Sync attributes whenever traits change
        this.on('change:target', this.updateTarget);

        // Initial sync
        // this.updateTarget();
      },
      updateTarget: function() {
        const target = this.get('target') || '_self';
        const attrs = this?.attributes?.attributes || {};  // get current attributes
        attrs.target = target;              // update target
        this.setAttributes(attrs);            // set merged attributes
      },
    },
  });
};
